(function($, Drupal) {
  'use strict';

  /*inicializamos scripts para que cargen en cuando finalice la carga del DOM */
  $(document).ready(function(){

    const countries = new Map([
      ['1', 'AFGANISTÁN'],
      ['2', 'ALBANIA'],
      ['3', 'ALEMANIA'],
      ['4', 'ANDORRA'],
      ['163', 'ANTIGUA Y BARBUDA'],
      ['5', 'ARABIA SAUDI'],
      ['6', 'ARGELIA'],
      ['7', 'ARGENTINA'],
      ['8', 'ARMENIA'],
      ['9', 'AUSTRALIA'],
      ['10', 'AUSTRIA'],
      ['11', 'AZERBAIYÁN'],
      ['12', 'BAHRÉIN'],
      ['13', 'BANGLADESH'],
      ['14', 'BARBADOS'],
      ['15', 'BÉLGICA'],
      ['16', 'BELICE'],
      ['164', 'BENÍN'],
      ['17', 'BIELORRUSIA'],
      ['18', 'BOLIVIA'],
      ['19', 'BOSNIA Y HERZEGOVINA'],
      ['20', 'BOTSUANA'],
      ['21', 'BRASIL'],
      ['22', 'BRUNÉI'],
      ['23', 'BULGARIA'],
      ['24', 'BURKINA FASO'],
      ['25', 'BURUNDI'],
      ['26', 'BUTÁN'],
      ['165', 'CABO VERDE'],
      ['27', 'CAMBOYA'],
      ['28', 'CAMERÚN'],
      ['29', 'CANADÁ'],
      ['166', 'CHAD'],
      ['30', 'CHILE'],
      ['31', 'CHINA'],
      ['32', 'CHIPRE'],
      ['33', 'COLOMBIA'],
      ['167', 'COMORAS'],
      ['168', 'COREA DEL NORTE'],
      ['34', 'COREA DEL SUR'],
      ['35', 'COSTA DE MARFIL'],
      ['36', 'COSTA RICA'],
      ['37', 'CROACIA'],
      ['38', 'CUBA'],
      ['39', 'DINAMARCA'],
      ['40', 'ECUADOR'],
      ['41', 'EGIPTO'],
      ['42', 'EL SALVADOR'],
      ['43', 'EMIRATOS ÁRABES UNIDOS'],
      ['169', 'ERITREA'],
      ['44', 'ESLOVAQUIA'],
      ['45', 'ESLOVENIA'],
      ['46', 'ESPAÑA'],
      ['47', 'ESTADOS UNIDOS DE AMÉRICA'],
      ['48', 'ESTONIA'],
      ['49', 'ETIOPÍA'],
      ['50', 'FILIPINAS'],
      ['51', 'FINLANDIA'],
      ['52', 'FRANCIA'],
      ['53', 'GABÓN'],
      ['54', 'GAMBIA'],
      ['55', 'GEORGIA'],
      ['56', 'GHANA'],
      ['57', 'GRECIA'],
      ['58', 'GROENLANDIA'],
      ['59', 'GUAM'],
      ['60', 'GUATEMALA'],
      ['171', 'GUAYANA'],
      ['61', 'GUAYANA FRANCESA'],
      ['170', 'GUINEA BISÁU'],
      ['62', 'GUINEA ECUATORIAL'],
      ['63', 'HAITÍ'],
      ['64', 'HOLANDA'],
      ['65', 'HONDURAS'],
      ['66', 'HONG KONG'],
      ['67', 'HUNGRÍA'],
      ['68', 'INDIA'],
      ['69', 'INDONESIA'],
      ['70', 'IRÁN'],
      ['71', 'IRAQ'],
      ['72', 'IRLANDA'],
      ['73', 'ISLANDIA'],
      ['74', 'ISRAEL'],
      ['75', 'ITALIA'],
      ['76', 'JAMAICA'],
      ['77', 'JAPÓN'],
      ['78', 'JORDANIA'],
      ['79', 'KAZAJISTÁN'],
      ['80', 'KENIA'],
      ['81', 'KIRGUISTÁN'],
      ['83', 'KUWAIT'],
      ['84', 'LAOS'],
      ['86', 'LESOTO'],
      ['87', 'LETONIA'],
      ['88', 'LÍBANO'],
      ['89', 'LIBERIA'],
      ['90', 'LÍBIA'],
      ['91', 'LITUANIA'],
      ['92', 'LUXEMBURGO'],
      ['93', 'MACEDONIA'],
      ['94', 'MADAGASCAR'],
      ['95', 'MALASIA'],
      ['96', 'MALAUI'],
      ['97', 'MALÍ'],
      ['98', 'MALTA'],
      ['99', 'MARRUECOS'],
      ['100', 'MARTINICA'],
      ['101', 'MAURICIO'],
      ['102', 'MAURITANIA'],
      ['103', 'MÉXICO'],
      ['104', 'MOLDAVIA'],
      ['105', 'MONGOLIA'],
      ['106', 'MONTENEGRO'],
      ['107', 'MOZAMBIQUE'],
      ['108', 'NAMIBIA'],
      ['109', 'NEPAL'],
      ['110', 'NICARAGUA'],
      ['111', 'NÍGER'],
      ['112', 'NIGERIA'],
      ['113', 'NORUEGA'],
      ['114', 'NUEVA ZELANDA'],
      ['115', 'OMÁN'],
      ['116', 'PAKISTÁN'],
      ['117', 'PALESTINA'],
      ['118', 'PANAMÁ'],
      ['119', 'PARAGUAY'],
      ['120', 'PERÚ'],
      ['121', 'POLONIA'],
      ['122', 'PORTUGAL'],
      ['123', 'PUERTO RICO'],
      ['124', 'QATAR'],
      ['125', 'REINO UNIDO'],
      ['126', 'REP DEMOCRÁTICA DEL CONGO'],
      ['128', 'REPÚBLICA CHECA'],
      ['130', 'REPÚBLICA DOMINICANA'],
      ['131', 'RUANDA'],
      ['132', 'RUMANÍA'],
      ['133', 'RUSIA'],
      ['134', 'SAHARA'],
      ['135', 'SAMOA'],
      ['136', 'SENEGAL'],
      ['137', 'SERBIA'],
      ['138', 'SIERRA LEONA'],
      ['139', 'SINGAPUR'],
      ['140', 'SIRIA'],
      ['141', 'SRI LANKA'],
      ['142', 'SUDÁFRICA'],
      ['143', 'SUDÁN'],
      ['144', 'SUECIA'],
      ['145', 'SUIZA'],
      ['146', 'SURINAM'],
      ['147', 'TAILANDIA'],
      ['148', 'TAIWÁN'],
      ['149', 'TANZANIA'],
      ['150', 'TOGO'],
      ['151', 'TÚNEZ'],
      ['152', 'TURKMENISTÁN'],
      ['153', 'TURQUÍA'],
      ['154', 'UCRANIA'],
      ['155', 'UGANDA'],
      ['156', 'URUGUAY'],
      ['157', 'UZBEKISTÁN'],
      ['158', 'VENEZUELA'],
      ['159', 'VIETNAM'],
      ['160', 'YEMEN'],
      ['161', 'ZAMBIA'],
      ['162', 'ZIMBABUE']
    ])
    const provinces = new Map([
      ['2', 'A Coruña'],
      ['3', 'Álava'],
      ['4', 'Albacete'],
      ['5', 'Alicante'],
      ['6', 'Almería'],
      ['7', 'Asturias'],
      ['8', 'Ávila'],
      ['9', 'Badajoz'],
      ['10', 'Barcelona'],
      ['11', 'Burgos'],
      ['12', 'Cáceres'],
      ['13', 'Cádiz'],
      ['14', 'Cantabria'],
      ['15', 'Castellón'],
      ['16', 'Ceuta'],
      ['17', 'Ciudad Real'],
      ['18', 'Córdoba'],
      ['19', 'Cuenca'],
      ['20', 'Girona'],
      ['21', 'Granada'],
      ['22', 'Guadalajara'],
      ['23', 'Guipúzcoa'],
      ['24', 'Huelva'],
      ['25', 'Huesca'],
      ['26', 'Islas Baleares'],
      ['27', 'Jaén'],
      ['28', 'La Rioja'],
      ['29', 'Las Palmas'],
      ['30', 'León'],
      ['31', 'Lleida'],
      ['32', 'Lugo'],
      ['33', 'Madrid'],
      ['34', 'Málaga'],
      ['35', 'Melilla'],
      ['36', 'Murcia'],
      ['37', 'Navarra'],
      ['38', 'Ourense'],
      ['39', 'Palencia'],
      ['40', 'Pontevedra'],
      ['41', 'Salamanca'],
      ['42', 'Santa Cruz de Tenerife'],
      ['43', 'Segovia'],
      ['44', 'Sevilla'],
      ['45', 'Soria'],
      ['46', 'Tarragona'],
      ['47', 'Teruel'],
      ['48', 'Toledo'],
      ['49', 'Valencia'],
      ['50', 'Valladolid'],
      ['51', 'Vizcaya'],
      ['52', 'Zamora'],
      ['1', 'Zaragoza']
    ])
    //Json con los prefijos de telefono de cada pais
    const countryPrefix = {
      '1': '93',
      '10': '43',
      '100': '596',
      '101': '230',
      '102': '222',
      '103': '52',
      '104': '373',
      '105': '976',
      '106': '382',
      '107': '258',
      '108': '264',
      '109': '977',
      '11': '994',
      '110': '505',
      '111': '227',
      '112': '234',
      '113': '47',
      '114': '64',
      '115': '968',
      '116': '92',
      '117': '970',
      '118': '507',
      '119': '595',
      '12': '973',
      '120': '51',
      '121': '48',
      '122': '351',
      '123': '1-787',
      '124': '974',
      '125': '44',
      '126': '243',
      '128': '420',
      '13': '880',
      '130': '1-809',
      '131': '250',
      '132': '40',
      '133': '7',
      '134': '212',
      '135': '685',
      '136': '221',
      '137': '381',
      '138': '232',
      '139': '65',
      '14': '1-246',
      '140': '963',
      '141': '94',
      '142': '27',
      '143': '249',
      '144': '46',
      '145': '41',
      '146': '597',
      '147': '66',
      '148': '886',
      '149': '66',
      '15': '32',
      '150': '228',
      '151': '216',
      '152': '993',
      '153': '90',
      '154': '380',
      '155': '256',
      '156': '598',
      '157': '998',
      '158': '58',
      '159': '84',
      '16': '501',
      '160': '967',
      '161': '260',
      '162': '263',
      '163': '1-268',
      '164': '229',
      '165': '238',
      '166': '235',
      '167': '269',
      '168': '850',
      '169': '291',
      '17': '375',
      '170': '245',
      '171': '592',
      '172': '95',
      '173': '960',
      '174': '244',
      '175': '379',
      '176': '423',
      '177': '377',
      '179': '675',
      '18': '591',
      '180': '236',
      '181': '224',
      '182': '378',
      '183': '239',
      '184': '248',
      '185': '252',
      '186': '268',
      '187': '992',
      '188': '670',
      '189': '1-868',
      '19': '387',
      '192': '1-264',
      '193': '672',
      '194': '599',
      '196': '297',
      '198': '1-242',
      '199': '1-441',
      '2': '355',
      '20': '267',
      '200': '47',
      '201': '1-345',
      '202': '61',
      '204': '61',
      '205': '242',
      '206': '682',
      '208': '599',
      '209': '253',
      '21': '55',
      '210': '1-767',
      '211': '298',
      '212': '679',
      '213': '350',
      '214': '1-473',
      '215': '590',
      '216': '44-1481',
      '219': '672',
      '22': '673',
      '220': '246',
      '221': '44',
      '222': '358',
      '223': '500',
      '224': '680',
      '225': '686',
      '226': '853',
      '227': '500',
      '228': '1-670',
      '229': '692',
      '23': '359',
      '230': '262',
      '231': '691',
      '232': '1-664',
      '233': '674',
      '234': '683',
      '235': '672',
      '236': '687',
      '237': '64',
      '238': '689',
      '239': '677',
      '24': '226',
      '240': '1-684',
      '241': '590',
      '242': '1-869',
      '243': '508',
      '244': '1-784',
      '245': '290',
      '246': '1-758',
      '248': '211',
      '249': '47',
      '25': '257',
      '252': '690',
      '253': '1-649',
      '254': '688',
      '255': '678',
      '256': '1-284',
      '257': '1-340',
      '258': '681',
      '26': '975',
      '27': '855',
      '28': '237',
      '29': '1',
      '3': '49',
      '30': '56',
      '31': '86',
      '32': '357',
      '33': '57',
      '34': '82',
      '35': '225',
      '36': '506',
      '37': '385',
      '38': '53',
      '39': '45',
      '4': '376',
      '40': '593',
      '41': '20',
      '42': '503',
      '43': '971',
      '44': '421',
      '45': '386',
      '46': '34',
      '47': '1',
      '48': '372',
      '49': '251',
      '5': '966',
      '50': '63',
      '51': '358',
      '52': '33',
      '53': '241',
      '54': '220',
      '55': '995',
      '56': '233',
      '57': '30',
      '58': '299',
      '59': '1-671',
      '6': '213',
      '60': '502',
      '61': '594',
      '62': '240',
      '63': '509',
      '64': '31',
      '65': '504',
      '66': '852',
      '67': '36',
      '68': '91',
      '69': '62',
      '7': '54',
      '70': '98',
      '71': '964',
      '72': '353',
      '73': '354',
      '74': '972',
      '75': '39',
      '76': '1-876',
      '77': '81',
      '78': '962',
      '79': '7',
      '8': '374',
      '80': '254',
      '81': '996',
      '83': '965',
      '84': '856',
      '86': '266',
      '87': '371',
      '88': '961',
      '89': '231',
      '9': '61',
      '90': '218',
      '91': '370',
      '92': '352',
      '93': '389',
      '94': '261',
      '95': '60',
      '96': '265',
      '97': '223',
      '98': '356',
      '99': '212',
    };


    /*************************************
     ******** FORMULARIO EMBEBIDO ********
     *************************************/

    if($('#solicitaInformacionEmbebido')){
      loadCountriesAndProvinces();
    }

    function loadCountriesAndProvinces(){
      const countrySelect = document.getElementById('country-embebido')
      countries.forEach((value, key)=>{
        var option = document.createElement("option");
        option.value = key;
        option.textContent = value;
        if (key === "46") {
          option.selected = true;
        }

        countrySelect.appendChild(option);
      })

      const provinceSelect = document.getElementById('province-embebido')
      provinces.forEach(function(value, key) {
        var option = document.createElement("option");
        option.value = key;
        option.textContent = value;
        provinceSelect.appendChild(option);
      });
    }

    //Al cambiar el país del formulario
    $('#country-embebido').change(function () {
      var pais = $('option:selected', this).val();
      //Desactivamos la provincia si no es España
      if (pais == 46) {
        $('#province-embebido').parent().css("display", "block");
      } else {
        $('#province-embebido').val("");
        $('#province-embebido').parent().css("display", "none");
      }
      //Cambiamos el prefijo de telefono
      if (countryPrefix[pais]) {
        $('#tlf-prefix-embebido').text('+' + countryPrefix[pais]);
      } else {
        $('#tlf-prefix-embebido').text('+');
      }
    });

    $('#formSolicitaInformacionEmbebed').submit(function (e) {
      e.preventDefault();
    }).validate({
      errorPlacement: function (error, element) {
        return true;
      },
      errorClass: "error",
      highlight: function (element, errorClass, validClass) {
        $(element).addClass(errorClass).removeClass(validClass);
        if (element.type === "checkbox") {
          $(element).parent().addClass("field-error");
        }
        if (element.type === "radio") {
          $(element).parent().parent().find("label").addClass("field-error");
        }
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).addClass(validClass).removeClass(errorClass);
        if (element.type === "checkbox") {
          $(element).parent().removeClass("field-error");
        }
        if (element.type === "radio") {
          $(element).parent().parent().find("label").removeClass("field-error");
        }
      },
      rules: {
        name: {required: true, maxlength: 50},
        lastname: {required: true, maxlength: 50},
        email: {required: true, validate_email: true, maxlength: 90},
        country: {required: true},
        tlf: {required: true, digits: true, maxlength: 40},
        observation: {maxlength: 450},
        videollamada: {required: true},
        inputTerms: {required: true},
        province: {
          required: function (element) {
            //SI ES ESPAÑA
            return $("#country-embebido").val() == 46 ? true : false;
          }
        },
        estudiosCursados: {required: true}
      },
      // Make sure the form is submitted to the destination defined
      // in the "action" attribute of the form when valid
      submitHandler: function (form, e) {
        sendAjaxInfoEmbebed(form);
      }
    });

    function sendAjaxInfoEmbebed(formulario) {
      $('.sk-fading-circle').show();
      $.ajax({
        url: "https://wscrm.ucam.edu/lead",
        method: 'post',
        dataType: 'json',
        data: $('#formSolicitaInformacionEmbebed').serialize().replace('tlf=', 'tlf=%2B' + $('#tlf-prefix-embebido').text().replace('+', '')),
        success: function (result) {
          var code = result.STATUS;
          if (code == 200) {
            $('.embebedFormContent').html('<div class="alert alert-success text-center" role="alert">' + Drupal.t("Thank You!") + '<br>' +Drupal.t("We have received your request for information. <br> You will receive an email shortly.") + '</div>');
          } else if (code == 500) {
            $('.embebedFormContent').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          } else {
            $('.embebedFormContent').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          }
          $('.sk-fading-circle.circle-embebido').hide();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $('.embebedFormContent').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          $('.sk-fading-circle.circle-embebido').hide();
        }
      });
    }

  })
})(jQuery, Drupal);
